// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f882a582","787":"eb60ea05"}[chunkId] + ".chunk.js";
};